import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./styles/global.css";

import DashboardPage from "./pages/dashboard";
import LoginPage from "./pages/login";
import ManageObjectives from "./pages/objectives/manage-objectives";
import CreateObjectives from "./pages/objectives/create-objectives";
import ManageLanguages from "./pages/languages/manage-languages";
import CreateLanguages from "./pages/languages/create-languages";
import ManageAdCategories from "./pages/ad-Categories/manage-ad-categories";
import CreateAdCategories from "./pages/ad-Categories/create-ad-categories";
import ManagePeople from "./pages/people/manage-people";
import ManageTeam from "./pages/teams/manage-teams";
import MediaAgencyOnboarding from "./pages/media-agency-onboarding";
import PrivateRoute from "./components/layout/PrivateRoute";
import MediaUserOnboarding from "./pages/media-user-onboarding";
import ManageRoles from "./pages/roles/manage-roles";
import UserPermissions from "./pages/roles/permissions";
import NotFound404Page from "./pages/404-page";
import ManageMediaAgency from "./pages/media-agency";
import Toast from "./components/ui/Toast";
import ProfileComponent from "./pages/profile";
import CampaignList from "./pages/campaign-list";
import ManageAdCategoriesPublishers from "./pages/ad-Categories/manage-ad-categories-publisher";
import ManageAdCategoriesAdTypes from "./pages/ad-Categories/manage-ad-categores-ad-types";
import ViewAdTypePreview from "./pages/ad-Categories/view-ad-type-preview";
import ViewArchivedPublishers from "./pages/ad-Categories/view-archived-publishers";
import ViewArchivedAdTypes from "./pages/ad-Categories/view-archived-ad-types";
import CreateCampaignWrapper from "./pages/Campaign";
import SettingsLayout from "./pages/settings";
import MainSettings from "./pages/settings/components/main-settings";
import CompanyDetails from "./pages/settings/components/company-details";
import SignInSecurity from "./pages/settings/components/sign-in-security";
import CampaignDetailWrapper from "./pages/campaign-detail";
import ManageNotifications from "./pages/notification/manage-notification";
import AdBuilder from "./pages/ad-builder";

const App: React.FC = () => {
  return (
    <Router>
      <Toast />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/media-agency/onboarding"
          element={<MediaAgencyOnboarding />}
        />

        <Route
          path="/media-user/onboarding"
          element={<MediaUserOnboarding />}
        />

        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/campaign-list" element={<CampaignList />} />
          <Route path="/objectives" element={<ManageObjectives />} />
          <Route path="/objectives/create" element={<CreateObjectives />} />
          <Route path="/languages" element={<ManageLanguages />} />
          <Route path="/languages/create" element={<CreateLanguages />} />
          <Route path="/ad-categories" element={<ManageAdCategories />} />
          <Route
            path="/ad-categories/publishers"
            element={<ManageAdCategoriesPublishers />}
          />
          <Route
            path="/ad-categories/ad-types"
            element={<ManageAdCategoriesAdTypes />}
          />
          <Route
            path="/ad-categories/view-ad-type"
            element={<ViewAdTypePreview />}
          />
          <Route
            path="/ad-categories/archived-publishers"
            element={<ViewArchivedPublishers />}
          />
          <Route
            path="/ad-categories/archived-ad-types"
            element={<ViewArchivedAdTypes />}
          />
          <Route
            path="/create-ad-categories"
            element={<CreateAdCategories />}
          />
          <Route path="/roles" element={<ManageRoles />} />
          <Route path="/roles/permissions" element={<UserPermissions />} />
          <Route path="/people" element={<ManagePeople />} />
          <Route path="/teams" element={<ManageTeam />} />
          <Route path="/profile" element={<ProfileComponent />} />
          <Route path="/media-agencies" element={<ManageMediaAgency />} />

          <Route path="/campaign" element={<CreateCampaignWrapper />} />
          <Route path="/campaign/flight" element={<CreateCampaignWrapper />} />
          <Route path="/campaign/assets" element={<CreateCampaignWrapper />} />
          <Route path="/campaign/summary" element={<CreateCampaignWrapper />} />

          <Route path="/notification" element={<ManageNotifications />} />

          <Route path="/ad-builder" element={<AdBuilder />} />

          <Route path="/account" element={<SettingsLayout />}>
            <Route index element={<MainSettings />} />
            <Route path="company-details" element={<CompanyDetails />} />
            <Route path="sign-in-security" element={<SignInSecurity />} />
          </Route>

          <Route path="/campaign/:campaignId">
            <Route index element={<CampaignDetailWrapper />} />
            <Route path="ad-category" element={<CampaignDetailWrapper />} />
            <Route path="ad-builder" element={<CampaignDetailWrapper />} />
          </Route>
          <Route path="*" element={<NotFound404Page />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
